export default __webpack_public_path__ + "static/media/project3.6e42708b.JPG";